'use client'

import { SolidButton } from '@macarongfactory/web-ui'
import Link from 'next/link'

import { MycleLogoDefault } from '@/shared/assets/icons'
import { ROUTES } from '@/shared/lib/routes'

import { CAR_STORY_APP_DOWNLOAD_LINKS } from '../lib'
import { carStoryTracking } from '../lib/tracking'

const HOME_LINK_LABEL = '차량 이야기 홈'

interface ICarStoryContentDetailExternalTopNavigationProps {
  contentId: number
}

const CarStoryContentDetailExternalTopNavigation = ({
  contentId,
}: ICarStoryContentDetailExternalTopNavigationProps) => {
  const handleAppDownload = () => {
    carStoryTracking.clickDetailTopDownload(contentId)
    window.location.href = CAR_STORY_APP_DOWNLOAD_LINKS.CONTENT_DETAIL_TOP
  }

  return (
    <div className='bg-background-surface-default sticky top-0 z-50'>
      <div className='h-dimension-x14 px-dimension-x5 flex items-center justify-between'>
        <Link
          href={ROUTES.CAR_STORY.HOME}
          aria-label={HOME_LINK_LABEL}
          className='flex'
        >
          <MycleLogoDefault fill='#00AFFF' width='120' height='24' />
        </Link>
        <SolidButton
          text='앱 다운로드'
          variant='brand'
          size='small'
          clickable={handleAppDownload}
        />
      </div>
    </div>
  )
}

export default CarStoryContentDetailExternalTopNavigation
